export default {
  title_one: '🥳 {{offer}} aplicada',
  title_other: '🥳 {{count}} ofertas aplicadas',
};
